'use client'

import dynamic from 'next/dynamic'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

const StoreFinder = dynamic(() =>
	import('maps/components/StoreLocator/StoreFinder/StoreFinder').then(
		(mod) => mod.StoreFinder
	)
)

const StoreFinderTabs = dynamic(() =>
	import('maps/components/StoreLocator/StoreFinderTabs/StoreFinderTabs').then(
		(mod) => mod.StoreFinderTabs
	)
)

export const StoreLocatorSwitcher = () => {
	const { isSmall } = useResponsive()

	return isSmall ? <StoreFinderTabs /> : <StoreFinder />
}
